<template>
    <div>
        <b-button class="mb-1 mt-1" @click="showBookingTrackModal()" size="xs" style="font-size: 0.675rem"> Subscription
            Summary</b-button>
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="booking-track-modal" hide-footer
            :title="Page_title">
            <b-tabs v-model="activeTab">
                <b-tab v-for="(container, index) in containerList" :key="index" :title="container"
                    @click="onTabChange(container)">
                    <div class="card">
                        <div class="card-header font-weight-bold" v-if="eventDet">
                            Last Movement Ass. Cont. No. : {{ activeTabContainer }} && Container No. : {{
                                eventDet.shipment_container_number }}
                        </div>
                        <div class="card-body">
                            <b-row>
                                <b-col md="4" v-if="eventDet">
                                    <b>Status : </b> {{ eventDet.status_verbose }}
                                </b-col>
                                <b-col md="4" v-if="eventDet">
                                    <b>Next Port : </b> {{ eventDet.current_vessel_nextport_name }}
                                </b-col>
                                <b-col md="4" v-if="eventDet">
                                    <b>Current Vessel : </b> {{ eventDet.current_vessel_name }}
                                </b-col>
                                <b-col md="4" v-if="eventDet">
                                    <b>Sline : </b> {{ eventDet.shipment_carrier_name }}
                                </b-col>
                                <b-col md="4" v-if="eventDet">
                                    <b>Sline Code : </b> {{ eventDet.shipment_carrier_scac }}
                                </b-col>
                                <b-col md="4">
                                    <b :style="(eventDet && eventDet.subscription_id) ? 'color: blue;font-weight:bold' : ''"
                                        @click="
                                            (eventDet && eventDet.subscription_id) ? goToSubscriptionPage(eventDet) : ''
                                            ">Booking No : {{ getBooking.booking_no }}</b>
                                </b-col>

                                <b-col md="4" v-if="
                                    getBooking.validity_doc != '' &&
                                    getBooking.validity_doc != undefined &&
                                    getBooking.validity_doc != null
                                ">
                                    <span v-if="getBooking.validity_doc">
                                        <b v-if="getBooking.validity_doc.split(',').length > 0">
                                            <span
                                                v-for="(item_doc, index_doc) in sanitizedArray(getBooking.validity_doc.split(','))"
                                                :key="index_doc">
                                                <a class="btn btn-xs btn-warning" size="sm" style="font-size: 0.675rem"
                                                    v-if="item_doc != ''" href="javascript:void(0)"
                                                    @click="PrintValidity_Doc(item_doc)">View
                                                    Doc - {{ index_doc + 1
                                                    }}</a>
                                                <br />
                                            </span>
                                        </b>
                                    </span>
                                </b-col>

                            </b-row>

                            <ShipmentTimeline v-if="eventDet" :eventDet="eventDet" />
                            <p class="mb-4">{{ event_msg }}</p>
                            <div class="table-responsive" v-if="movementData.length > 0">
                                <table class="table table-bordered table-hover table-sm">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Status</th>
                                            <th>Place of Activity</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Transport</th>
                                            <th>Voyage No.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(entry, index) in movementData" :key="index">
                                            <td>{{ entry.status }}</td>
                                            <td>{{ entry.place }}</td>
                                            <td>{{ entry.date }}</td>
                                            <td>{{ entry.time }}</td>
                                            <td>{{ entry.transport }}</td>
                                            <td>{{ entry.voyage || '-' }}</td>
                                        </tr>
                                    </tbody>

                                </table>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>ETA DESTINATION ESTIMATED</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.dlv_delivery_planned_initial
                                                    ? formatDate(eventDet.dlv_delivery_planned_initial) : '-')
                                            }}</td>
                                            <td>{{ "Last : " +
                                                (eventDet.dlv_delivery_planned_last ?
                                                    formatDate(eventDet.dlv_delivery_planned_last)
                                                    :
                                                    '-')
                                            }}
                                            </td>
                                            <td>ETA DESTINATION ACTUAL</td>
                                            <td>{{ "Actual : " +
                                                (eventDet.pod_vslarrival_actual ?
                                                    formatDate(eventDet.pod_vslarrival_actual) : '-')
                                            }}
                                            </td>
                                            <td>{{ "Detected : " +
                                                (eventDet.pod_vslarrival_detected ?
                                                    formatDate(eventDet.pod_vslarrival_detected) :
                                                    '-')
                                            }}
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                            <td>EMPTY PICKUP ACTUAL(Origin)</td>
                                            <td>{{ "Actual : " + (eventDet.empty_pickup_actual ?
                                                formatDate(eventDet.empty_pickup_actual) :
                                                '-')
                                            }}</td>
                                            <td></td>
                                            <td>Container PICKUP PLANNED (Destination)</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.empty_pickup_planned_initial ?
                                                    formatDate(eventDet.empty_pickup_planned_initial)
                                                    :
                                                    eventDet.pod_vslarrival_planned_initial ?
                                                        formatDate(eventDet.pod_vslarrival_planned_initial) : '-')
                                            }}</td>
                                            <td>{{ "Last : " +
                                                (eventDet.empty_pickup_planned_last ?
                                                    formatDate(eventDet.empty_pickup_planned_last)
                                                    :
                                                    eventDet.pod_vslarrival_planned_last ?
                                                        formatDate(eventDet.pod_vslarrival_planned_last) : '-')
                                            }}</td>
                                        </tr>
                                        <tr>
                                            <!-- <td>EMTY PICKUP PLANNED (Destination)</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.empty_pickup_planned_initial ?
                                                    formatDate(eventDet.empty_pickup_planned_initial)
                                                    :
                                                    eventDet.pod_vslarrival_planned_initial ?
                                                        formatDate(eventDet.pod_vslarrival_planned_initial) : '-')
                                            }}</td>
                                            <td>{{ "Last : " +
                                                (eventDet.empty_pickup_planned_last ?
                                                    formatDate(eventDet.empty_pickup_planned_last)
                                                    :
                                                    eventDet.pod_vslarrival_planned_last ?
                                                        formatDate(eventDet.pod_vslarrival_planned_last) : '-')
                                            }}</td> -->
                                            <td>EMPTY Return POD(Destination) :{{ eventDet.empty_return_loc_name }}</td>
                                            <td>{{ "Actual : " + (eventDet.empty_return_actual ?
                                                formatDate(eventDet.empty_return_actual) :
                                                '-')
                                            }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>POR PLANNED</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.origin_pickup_planned_initial
                                                    ? formatDate(eventDet.origin_pickup_planned_initial) : '-')
                                            }}</td>
                                            <td></td>
                                            <td>POR ACTUAL</td>
                                            <td>{{ "Actual : " +
                                                (eventDet.origin_pickup_actual ?
                                                    formatDate(eventDet.origin_pickup_actual) : '-') }}
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>POL PLANNED ARRIVAL</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.pol_arrival_planned_initial ?
                                                    formatDate(eventDet.pol_arrival_planned_initial)
                                                    :
                                                    '-')
                                            }}</td>
                                            <td></td>
                                            <td>POL ARRIVAL ACTUAL</td>
                                            <td>{{ "Actual : " + (eventDet.pol_arrival_actual ?
                                                formatDate(eventDet.pol_arrival_actual)
                                                :
                                                '-')
                                            }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>POL LOADED ACTUAL</td>
                                            <td>{{ "Actual : " + (eventDet.pol_loaded_actual ?
                                                formatDate(eventDet.pol_loaded_actual) :
                                                '-')
                                            }}
                                            </td>
                                            <td></td>
                                            <td>SOB PLANNED</td>
                                            <td>{{ "Initial : " +
                                                (eventDet.pol_vsldeparture_planned_initial ?
                                                    formatDate(eventDet.pol_vsldeparture_planned_initial) : '-')
                                            }}</td>
                                            <td>{{ "Last : " +
                                                (eventDet.pol_vsldeparture_planned_last
                                                    ? formatDate(eventDet.pol_vsldeparture_planned_last) : '-')
                                            }}</td>
                                        </tr>
                                        <tr>
                                            <td>SOB ACTUAL</td>
                                            <td>{{ "Actual : " +
                                                (eventDet.pol_vsldeparture_actual ?
                                                    formatDate(eventDet.pol_vsldeparture_actual) :
                                                    '-')
                                            }}
                                            </td>
                                            <td>{{ "Detected : " +
                                                (eventDet.pol_vsldeparture_detected ?
                                                    formatDate(eventDet.pol_vsldeparture_detected)
                                                    :
                                                    '-')
                                            }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>
    </div>
</template>

<script>
import TrasportService from '../../services/TrasportService';
import ShipmentTimeline from '../tracking/ShipmentTimeline.vue';
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";

export default {
    name: "MovementTable",
    props: {
        containerArr: {
            type: String,
            default: "",
        },
        slineName: {
            type: String,
            default: "",
        },
        clientName: {
            type: String,
            default: "",
        },
        modal_title: {
            type: String,
            default: "",
        },
        JOBNO: {
            type: String,
            default: "",
        },
        shipment_id: {
            type: Number,
            default: "",
        },
        subscription_id: {
            type: Number,
            default: "",
        },
        fk_sub_track_id: {
            type: Number,
            default: "",
        },
        fk_all_module_id: {
            type: Number,
            default: "",
        },
        fk_booking_id: {
            type: Number,
            default: "",
        },
        fk_container_id: {
            type: Number,
            default: "",
        },
        booking_number: {
            type: String,
            default: "",
        },
        container_number: {
            type: String,
            default: "",
        },
    },
    beforeMount() { },
    data() {
        return {
            Page_title: this.modal_title,
            eventDet: {},
            movementData: [],
            containerList: [],
            activeTab: '',
            activeTabContainer: '',
            getBooking: {},
            docURL: URL_BASE_DOC,
            event_msg: '',
        };
    },
    mounted() { },
    beforeDestroy() { },

    destroyed() { },

    components: {
        ShipmentTimeline
    },
    computed: {},
    watch: {},
    methods: {
        goToSubscriptionPage(item) {
            if (item.subscription_id) {
                this.$router.push({
                    path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
                });
            }
        },
        sanitizedArray(validity_doc) {
            // Use the map method to replace "\n" with []
            const replacedArray = validity_doc.map((item) => {
                if (item === "\n") {
                    return [];
                } else {
                    return item;
                }
            });
            // Flatten the replacedArray and remove empty arrays
            const flattenedArray = replacedArray.reduce((acc, curr) => {
                if (Array.isArray(curr) && curr.length === 0) {
                    return acc;
                }
                return acc.concat(curr);
            }, []);

            // console.log("validity_doc2 =>", flattenedArray);
            return flattenedArray;
        },
        PrintValidity_Doc(validity_doc) {
            this.openSignedDocument(`ASSIGNMENT_UPLOADS/Console_Booking_Doc/${validity_doc}`);
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                minute = d.getMinutes(),
                Hour = d.getHours(),
                second = d.getSeconds();

            if (month.length < 2) month = "0" + month;

            if (day.length < 2) day = "0" + day;

            let dateNew = [year, month, day].join("-");

            return dateNew;
        },
        onTabChange(container) {
            this.getBookingTrack(container);
        },
        async getBookingTrack(firstContainer) {
            this.activeTabContainer = firstContainer;
            let payload = {
                JOBNO: this.JOBNO,
                shipment_id: this.shipment_id,
                subscription_id: this.subscription_id,
                fk_sub_track_id: this.fk_sub_track_id,
                fk_all_module_id: this.fk_all_module_id ? this.fk_all_module_id : 0,
                fk_booking_id: this.fk_booking_id,
                fk_container_id: this.fk_container_id,
                booking_number: this.booking_number,
                container_number: firstContainer ? firstContainer : this.container_number,
            };
            let getTrack = await TrasportService.getSubscriptionTrack(payload, {});
            this.movementData = (getTrack.data && getTrack.data.data) ? getTrack.data.data : [];
            this.event_msg = (getTrack.data && getTrack.data.result) && getTrack.data.result.event_details_message;
            this.eventDet = (getTrack.data && getTrack.data.result) && getTrack.data.result;
            this.getBooking = getTrack.data.getBooking;
            if (!this.activeTabContainer) {
                this.activeTabContainer = getTrack.data.getContainerList[0].containerNo;
                this.containerList = getTrack.data.getContainerList.map((item) => item.containerNo);
            }
            console.log("getTrack=>", payload, getTrack, this.containerList);
        },
        showBookingTrackModal() {
            this.BookingTrackList = [];
            this.$refs["booking-track-modal"].show();

            this.containerList = this.containerArr ? this.containerArr.split(',') : [];
            this.activeTab = this.containerList[0] || '';
            // if (this.activeTab) {
            this.getBookingTrack(this.activeTab);
            // }
        },
        hideBookingTrackModal() {
            this.BookingTrackList = [];
            this.$refs["booking-track-modal"].hide();
        },
    }
};
</script>

<style scoped>
.card {
    border: 1px solid #ccc;
}

.table th,
.table td {
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// bookingTrack.vue?7753e2e6